import {
    put,
    takeLatest,
} from 'redux-saga/effects'

import {
    SET_CURRENT_PAGE,
    SET_CURRENT_PAGE_REQUESTED,
    SET_PAGE_BACKGROUND,
    SET_PAGE_BACKGROUND_REQUESTED,
} from '../actions/common-actions'

function* setCurrentPage({ payload }) {
    yield put({ type: SET_CURRENT_PAGE, payload })
}

function* setPageBackground({ payload }) {

    yield put({ type: SET_PAGE_BACKGROUND, payload })
}

export default function* commonSaga() {
    yield takeLatest(SET_CURRENT_PAGE_REQUESTED, setCurrentPage)
    yield takeLatest(SET_PAGE_BACKGROUND_REQUESTED, setPageBackground)
}
